// Messages for operator/AcceptInvitation (auto-merged by lib/i18n.ts).
export const en = {
  'operator.accept_invitation.head_invalid': 'Invitation — Operator',
  'operator.accept_invitation.invalid_title': 'Invitation not valid',
  'operator.accept_invitation.invalid_body':
    'This invitation link is invalid, has expired, or has already been used. Ask an administrator to re-send it.',
  'operator.accept_invitation.head': 'Accept invitation — Operator',
  'operator.accept_invitation.title': 'Set your password',
  'operator.accept_invitation.activating': 'Activating {email}',
  'operator.accept_invitation.password_label': 'Choose a password (at least 12 characters)',
  'operator.accept_invitation.password_error': 'Password {error}',
  'operator.accept_invitation.submit': 'Activate account',
}

export const zhTW = {
  'operator.accept_invitation.head_invalid': '邀請 — 操作端',
  'operator.accept_invitation.invalid_title': '邀請無效',
  'operator.accept_invitation.invalid_body':
    '此邀請連結無效、已過期或已被使用。請聯絡管理員重新傳送。',
  'operator.accept_invitation.head': '接受邀請 — 操作端',
  'operator.accept_invitation.title': '設定您的密碼',
  'operator.accept_invitation.activating': '正在啟用 {email}',
  'operator.accept_invitation.password_label': '選擇密碼（至少 12 個字元）',
  'operator.accept_invitation.password_error': '密碼{error}',
  'operator.accept_invitation.submit': '啟用帳戶',
}
